/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

const NavMenu: React.LegacyFunctionComponentWithChildren<{}> = ({ children }) => {
  return <div css={{ display: 'flex', alignItems: 'center', height: '100%' }}>{children}</div>;
};

export default NavMenu;
